import { Component, ElementRef, inject, input, linkedSignal } from '@angular/core';

@Component({
  selector: 'ui-tooltip',
  templateUrl: './tooltip.html',
  styleUrl: './tooltip.css',
  host: {
    '[style.position-anchor]': 'positionAnchor()',
    '[attr.id]': 'id()',
    '[attr.role]': '"tooltip"',
  },
})
export class TooltipComponent {
  private elementRef = inject<ElementRef<HTMLElement>>(ElementRef<HTMLElement>);

  id = input<string>(`ui-tooltip-${crypto.randomUUID()}`);
  anchorName = input<`--${string}` | null>(null);
  positionAnchor = linkedSignal(this.anchorName);

  toggle() {
    this.elementRef.nativeElement.togglePopover();
  }

  show() {
    this.elementRef.nativeElement.showPopover();
  }

  hide() {
    this.elementRef.nativeElement.hidePopover();
  }
}
